import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['hut', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-2.5h1v2.5h-1zM-0.5,-2h0.5v2h-0.5zM-1,0h1v0.5h-1z',
    },
    {
      paint: [
        ['hut', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2,-2.5h0.5v2.5h-0.5zM1.5,-2.5h1v0.5h-1zM-1,-2h0.5v2h-0.5zM0.5,-2h2v0.5h-2zM0,-1.5h2.5v1h-2.5zM0,-0.5h2v0.5h-2zM-1.5,0h0.5v0.5h-0.5zM0,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-6h0.5v0.5h-0.5zM-2,-5.5h1v0.5h-1zM-2,-5h1.5v0.5h-1.5zM-2.5,-4.5h2v0.5h-2zM-3,-4h3v0.5h-3zM-3.5,-3.5h3.5v0.5h-3.5zM-2,-3h2v0.5h-2z',
    },
    {
      paint: 'roofB',
      d: 'M-1,-6h0.5v0.5h-0.5zM-1,-5.5h1.5v0.5h-1.5zM-0.5,-5h2v0.5h-2zM-0.5,-4.5h2.5v0.5h-2.5zM0,-4h2.5v1h-2.5zM0,-3h2v0.5h-2zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M2.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1.5v0.5h-1.5zM2,-3h1v0.5h-1zM-1,-2.5h1v0.5h-1zM1,-2.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-1.5,-2.5h0.5v2.5h-0.5z' },
  ],
  pixels: 120,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'hut',
      d: 'M-2.5,-2.5h0.5v0.5h-0.5zM-2.5,-2h1.5v2h-1.5zM2,-0.5h0.5v0.5h-0.5zM-1.5,0h1.5v0.5h-1.5zM0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['hut', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M2,-2.5h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM0,-2h2.5v0.5h-2.5zM0.5,-1.5h2v1h-2zM0.5,-0.5h1.5v0.5h-1.5zM0,0h0.5v0.5h-0.5zM1,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-0.5,-6h0.5v0.5h-0.5zM0,-5.5h0.5v0.5h-0.5zM0,-5h1v0.5h-1zM0,-4.5h1.5v0.5h-1.5zM0,-4h2v0.5h-2zM0,-3.5h2.5v0.5h-2.5zM0,-3h3v0.5h-3zM0,-2.5h1v0.5h-1z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1,-5.5h1v0.5h-1zM-1.5,-5h1.5v0.5h-1.5zM-2,-4.5h2v0.5h-2zM-2.5,-4h2.5v1h-2.5zM-3,-3h3v0.5h-3zM-2,-2.5h2v0.5h-2z',
    },
    { paint: 'trunk', d: 'M-0.5,-2h0.5v0.5h-0.5zM-1,-1.5h1.5v1.5h-1.5z' },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M1,-2.5h1v0.5h-1z',
    },
  ],
  pixels: 103,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['hut', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-2.5h1v2.5h-1zM-0.5,-2h0.5v2h-0.5zM-1,0h1v0.5h-1z',
    },
    {
      paint: [
        ['hut', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2,-2.5h0.5v2.5h-0.5zM1.5,-2.5h1v0.5h-1zM-1,-2h0.5v2h-0.5zM0.5,-2h1.5v0.5h-1.5zM0,-1.5h2.5v1h-2.5zM0,-0.5h2v0.5h-2zM-1.5,0h0.5v0.5h-0.5zM0,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-6h0.5v0.5h-0.5zM-2,-5.5h1v0.5h-1zM-2,-5h1.5v0.5h-1.5zM-2.5,-4.5h2v0.5h-2zM-3,-4h3v0.5h-3zM-3.5,-3.5h3.5v0.5h-3.5zM-2,-3h2v0.5h-2z',
    },
    {
      paint: 'roofB',
      d: 'M-1,-6h0.5v0.5h-0.5zM-1,-5.5h1.5v0.5h-1.5zM-0.5,-5h2v0.5h-2zM-0.5,-4.5h2.5v0.5h-2.5zM0,-4h2.5v1h-2.5zM0,-3h2v0.5h-2zM0,-2.5h1v0.5h-1zM2.5,-2.5h2v0.5h-2zM2.5,-2h2.5v1h-2.5zM3,-1h0.5v1.5h-0.5zM4.5,-1h0.5v1h-0.5z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M2.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h1.5v0.5h-1.5zM2,-3h1v0.5h-1zM-1,-2.5h1v0.5h-1zM1,-2.5h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5zM2,-2h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-1.5,-2.5h0.5v2.5h-0.5z' },
  ],
  pixels: 139,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
